import { Box, Button, Checkbox, Container, FormControlLabel, Grid, InputAdornment, Paper, TextField, Typography, useMediaQuery, useTheme } from "@mui/material";
import React, { useState, useEffect  }  from "react";
import { useNotification } from "../../context/notification.context";
import { RegisterValidate } from "../../utils/validateForm";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import bcrypt from 'bcryptjs';
import berhu from "../../assets/img/Berhu.png";
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import Person from '@mui/icons-material/PersonOutlineOutlined';
import Lock from '@mui/icons-material/LockOutlined';
import GoogleIcon from '@mui/icons-material/Google';
import { CheckBox } from "@mui/icons-material";
import GoogleAuthButton from "../googleAuth/GoogleAuth";
type RegisterType = {
  username: string;
  email: string;
  password: string;
  confpassword: string;
};


export const RegisterPage: React.FC<{}> = () => {
  const nav = useNavigate();
  const { getError, getSuccess } = useNotification();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const tm = '250px';
  const tc = '597px';

  const [registerData, setRegisterData] = useState<RegisterType>({
    username: "",
    email: "",
    password: "",
    confpassword: "",
  });

  const dataRegister = (e: React.ChangeEvent<HTMLInputElement>) => {
    setRegisterData({ ...registerData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e: React.FormEvent<HTMLInputElement>) => {
    e.preventDefault();

    if (registerData.password !== registerData.confpassword) {
      getError("Las contraseñas no coinciden");
      return;
    }

    try {
      await RegisterValidate.validate(registerData);

      // Enviar datos al servidor
      const response = await axios.post("http://localhost:5001/api/addUser", {
        username: registerData.username,
        email: registerData.email,
        password: registerData.password, // Enviar la contraseña para encriptarla en el backend
      });

      getSuccess("Registro correcto");
      nav("/");
    } catch (error: any) {
      getError(error.message);
    }
  };


  return (
    <Container maxWidth="xl" sx={{
      display: 'flex',
      position: 'relative',
      height: '100%'
    }}>
      <Grid
        container
        direction={"column"}
        alignItems={"center"}
        justifyContent={"center"}
        sx={{ minHeight: "100vh" }}
      >
        <Grid item>
          {!isMobile && <Button
            type="button"
            variant="contained"
            sx={{
              mt: 20,
              height: "250px",
              writingMode: "vertical-rl",
              borderRadius: "0px 50px 50px 0px",
              background: "white",
              float: "inline-end",
              fontSize: "30px",
              padding: "0px",
              ":hover": {
                background: "#FEE483"
              }
            }}
            onClick={() => nav("/")}
          >
            Iniciar Sesión
          </Button>}
          <Paper sx={{
            mt: isMobile ? 0.5 : 3,
            mb: isMobile ? 0.5 : 3,
            padding: "1.2em",
            borderRadius: "3em",
            background: "white",
            height: isMobile ? "93vh" : "700px",
            width: isMobile ? "100%" : "70em",
            alignContent: "center",
            position: "static"
          }}>
            <img src={berhu} style={{
              alignContent: "center",
              marginLeft: isMobile ? 0 : "15em",
            }}></img>
            <Box component={"form"} onSubmit={handleSubmit} sx={{
              display: isMobile ? "flex" : '',
              flexDirection: isMobile ? "column" : '',
              justifyContent: "center"
            }}>
              <Box sx={{
                alignContent: "center",
                justifyItems: "center",
                display: isMobile ? "flex" : ''
              }}>
                <Person sx={{
                  color: 'black',
                  mt: isMobile ? 5 : 1,
                  mr: isMobile ? 0.5 : 50,
                  ml: isMobile ? 2 : 26,
                  mb: isMobile ? '' : -12,
                  alignSelf: "flex-start"
                }} />
                <TextField
                  name="username"
                  margin="normal"
                  variant="standard"
                  type="text"
                  label="Nombre"
                  sx={{
                    mt: isMobile ? '' : 1,
                    mb: isMobile ? '' : 1.5,
                    mr: isMobile ? 1 : 50,
                    ml: isMobile ? 1 : 30,
                    width: isMobile ? tm : tc,
                    alignSelf: "center"
                  }}
                  onChange={dataRegister}
                />
              </Box>
              <Box>
                <AccountCircleOutlinedIcon sx={{
                  color: 'black',
                  mt: isMobile ? 0 : 0,
                  mr: isMobile ? 0.5 : 50,
                  ml: isMobile ? 2 : 26,
                  mb: isMobile ? -9 : -12,
                  alignSelf: "flex-start"
                }} />
                <TextField
                  name="email"
                  margin="normal"
                  variant="standard"
                  type="email"
                  label="Correo Electrónico"
                  sx={{
                    mt: isMobile ? '' : 0,
                    mr: isMobile ? 1 : 50,
                    ml: isMobile ? 1 : 30,
                    width: isMobile ? tm : tc,
                    alignSelf: "center"
                  }}
                  onChange={dataRegister}
                />
              </Box>
              <Box>
                <Lock sx={{
                  color: 'black',
                  mt: isMobile ? 0 : 1,
                  mr: isMobile ? 0.5 : 50,
                  ml: isMobile ? 2 : 26,
                  mb: isMobile ? -9 : -12,
                  alignSelf: "flex-start"
                }} />
                <TextField
                  name="password"
                  margin="normal"
                  variant="standard"
                  type="password"
                  label="Contraseña"
                  sx={{
                    mt: isMobile ? '' : 1,
                    mr: isMobile ? 1 : 50,
                    ml: isMobile ? 1 : 30,
                    width: isMobile ? tm : tc,
                    alignSelf: "center"
                  }}
                  onChange={dataRegister}
                />
              </Box>
              <Box>
                <Lock sx={{
                  color: 'black',
                  mt: isMobile ? 0 : 1,
                  mr: isMobile ? 0.5 : 50,
                  ml: isMobile ? 2 : 26,
                  mb: isMobile ? -9 : -12,
                  alignSelf: "flex-start"
                }} />
                <TextField
                  name="confpassword"
                  margin="normal"
                  variant="standard"
                  type="password"
                  label="Confirmar Contraseña"
                  sx={{
                    mt: isMobile ? '' : 1,
                    mr: isMobile ? 1 : 50,
                    ml: isMobile ? 1 : 30,
                    width: isMobile ? tm : tc,
                    alignSelf: "center"
                  }}
                  onChange={dataRegister}
                />
              </Box>
              <FormControlLabel
                required
                control={<Checkbox sx={{
                  mt: isMobile ? 2 : 1,
                  mb: isMobile ? '' : 1,
                  ml: isMobile ? 5 : 45,
                  '&.Mui-checked': {
                    color: "#FEE483",
                  },
                }} />}
                label="Acepto los términos y conidiciones"
              />
              <Button
                type="submit"
                variant="contained"
                sx={{
                  mt: isMobile ? 2 : 1.5,
                  mb: isMobile ? 1 : 3,
                  mr: isMobile ? '' : 50,
                  ml: isMobile ? 2.5 : 45,
                  width: isMobile ? '300px' : "341px",
                  borderRadius: "50px 50px 50px",
                  fontSize: "20px",
                  fontFamily: "unset",
                  ":hover": {
                    background: "#FEE483"
                  }
                }}
              >
                Crear Cuenta
              </Button>
              <Box sx={{
                justifyContent: "center",
                alignContent: "center"
              }}>
                <label style={{
                  marginRight: isMobile ? '' : "50px",
                  marginLeft: isMobile ? 120 : "30em"
                }}
                >
                  O ingresar con:

                </label>
                <GoogleAuthButton />
              </Box>
            </Box>
            {isMobile && <Button
              type="button"
              variant="contained"
              sx={{
                // mt: 20,
                mb: "-90%",
                ml: -2.4,
                height: "50px",
                width: "200px",
                borderRadius: "0px 3em 0px 3em",
                background: "white",
                fontSize: "20px",
                padding: "0px",
                borderBottomColor: "black",
                borderTopColor: "grey",
                borderBottom: 3,
                borderTop: 2,
                position: "absolute",
                bottom: '20.8em',
                ":hover": {
                  background: "#FEE483"
                }
              }}
              onClick={() => nav("/")}
            >
              Iniciar Sesión
            </Button>}
          </Paper>
        </Grid>
      </Grid>
    </Container>
  );
};
